export class Feature {
  name: string;
  isActive: boolean;
  value: any = null;
  constructor(name: string, value: any) {
    this.name = name;
    if (typeof value === 'boolean') {
      this.isActive = value;
    }
    else {
      this.isActive = value?.isActive;
      this.value = value;
    }
  }
}
